import { render } from "./Bookmark.vue?vue&type=template&id=34358cd8"
import script from "./Bookmark.vue?vue&type=script&lang=js"
export * from "./Bookmark.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "34358cd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34358cd8', script)) {
    api.reload('34358cd8', script)
  }
  
  module.hot.accept("./Bookmark.vue?vue&type=template&id=34358cd8", () => {
    api.rerender('34358cd8', render)
  })

}

script.__file = "src/icons/components/filled/Bookmark.vue"

export default script